import { Table } from 'antd';

export const IsoTable = Table;
